export default __webpack_public_path__ + "static/homeVp1-6680610cd2cfa8adc63c2cd96a55ce1a.png";